export type DatasetType = "delivery" | "sample" | "volume_upgrade" | "state" | "country";

export type ExportType = "analysis" | "brand_analysis" | "brand_discovery" | "chains" | "duplicates" | "place_export" | "saga_diff";

export const placeSetTypeToDatasetType: Record<string, DatasetType> = {
  Delivery: "delivery",
  Sample: "sample",
  VolumeUpgrade: "volume_upgrade",
  State: "state",
  Country: "country",
};

export type StructureStats_T = {
  id: number;
  delivery_id: number;
  delivery_name: string;
  export_id: number;
  current_file_size_kb: number;
  previous_file_size_kb: number;
  within_file_size_threshold: boolean;
  current_row_count: number;
  previous_row_count: number;
  file_size_pct_diff: number;
  row_count_pct_diff: number;
  row_count_diff: number;
  within_row_count_threshold: boolean;
  file_extension: string;
  previous_column_count: number;
  current_column_count: number;
  column_count_diff: number;
  same_type: boolean;
  within_column_count_threshold: boolean;
  within_same_type_threshold: boolean;
};